import { NgModule, inject } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { CanActivateCms } from './auth/can-activate-cms';
import { LoginComponent } from './auth/login.component';
import { HomeComponent } from './home.component';
import { ShortenerComponent } from './shortener.component';
import { RegisterComponent } from './auth/register/register.component';
import { isWebClient } from './utility/app.utils';
import { environment } from 'src/environments/environment';

const cmsRoutes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'cms',
    loadChildren: () => import('./cms/cms.module').then((m) => m.CmsModule),
    canActivate: [CanActivateCms],
  },
  {
    path: 'course',
    loadChildren: () =>
      import('./course/course.module').then((m) => m.CourseModule),
  },
  {
    path: 'book',
    loadChildren: () =>
      import('./course/course.module').then((m) => m.CourseModule),
  },
  {
    path: 'exam',
    loadChildren: () => import('./exam/exam.module').then((m) => m.ExamModule),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'process-payment',
    loadComponent: () =>
      import('./profile/process-payment/process-payment.component').then(
        (c) => c.ProcessPaymentComponent
      ),
  },
  {
    path: 'live-events',
    loadChildren: () =>
      import('./live-event/live-event.module').then((m) => m.LiveEventModule),
  },
  {
    path: 'prototype/transcript',
    loadChildren: () =>
      import('./prototype/transcript/transcript.module').then(
        (m) => m.TranscriptModule
      ),
    canActivate: [
      () => {
        // Only make this route available in dev environments
        const router: Router = inject(Router);
        const isProduction = !environment.production;
        if (!isProduction) {
          router.navigate(['/login']);
        }
        return isProduction;
      },
    ],
  },
];

const authRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'register',
    component: RegisterComponent,
  },
];

const extraRoutes: Routes = [
  // Link shortening
  {
    path: ':anyid',
    component: ShortenerComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];

let routes: Routes = cmsRoutes;

if (!isWebClient()) {
  routes = [...cmsRoutes, ...authRoutes];
}

routes = [...routes, ...extraRoutes];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
